/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvailableRoom } from './AvailableRoom';
import {
    AvailableRoomFromJSON,
    AvailableRoomFromJSONTyped,
    AvailableRoomToJSON,
    AvailableRoomToJSONTyped,
} from './AvailableRoom';

/**
 * 
 * @export
 * @interface RoomAvailabilityResult
 */
export interface RoomAvailabilityResult {
    /**
     * 
     * @type {number}
     * @memberof RoomAvailabilityResult
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof RoomAvailabilityResult
     */
    checkin: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoomAvailabilityResult
     */
    checkout: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RoomAvailabilityResult
     */
    betterRoomsAvailable: boolean;
    /**
     * 
     * @type {Array<AvailableRoom>}
     * @memberof RoomAvailabilityResult
     */
    rooms?: Array<AvailableRoom> | null;
}

/**
 * Check if a given object implements the RoomAvailabilityResult interface.
 */
export function instanceOfRoomAvailabilityResult(value: object): value is RoomAvailabilityResult {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('betterRoomsAvailable' in value) || value['betterRoomsAvailable'] === undefined) return false;
    return true;
}

export function RoomAvailabilityResultFromJSON(json: any): RoomAvailabilityResult {
    return RoomAvailabilityResultFromJSONTyped(json, false);
}

export function RoomAvailabilityResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomAvailabilityResult {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'checkin': (new Date(json['checkin'])),
        'checkout': (new Date(json['checkout'])),
        'betterRoomsAvailable': json['better_rooms_available'],
        'rooms': json['rooms'] == null ? undefined : ((json['rooms'] as Array<any>).map(AvailableRoomFromJSON)),
    };
}

export function RoomAvailabilityResultToJSON(json: any): RoomAvailabilityResult {
    return RoomAvailabilityResultToJSONTyped(json, false);
}

export function RoomAvailabilityResultToJSONTyped(value?: RoomAvailabilityResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'].toISOString().substring(0,10),
        'checkout': value['checkout'].toISOString().substring(0,10),
        'better_rooms_available': value['betterRoomsAvailable'],
        'rooms': value['rooms'] == null ? undefined : ((value['rooms'] as Array<any>).map(AvailableRoomToJSON)),
    };
}

